var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t("default"),
      _c(
        "yxt-button",
        { attrs: { type: "plain" }, on: { click: _vm.cancel } },
        [_vm._v(_vm._s(_vm.$t("pc_biz_udp_btn_cancel" /* 取消 */)))]
      ),
      _c(
        "yxt-button",
        { attrs: { type: "primary" }, on: { click: _vm.submit } },
        [_vm._v(_vm._s(_vm.$t("pc_save" /* 保存 */)))]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }